export var getStyles = function (props) {
    var theme = props.theme;
    return {
        root: {},
        headerButtonsContainer: {
            flex: '1 1 auto'
        },
        backButton: {
            padding: '0px',
            height: '40px',
            color: theme.palette.neutralPrimary
        }
    };
};
//# sourceMappingURL=CoherencePanelNavigation.styles.js.map